import styled, { keyframes } from 'styled-components'

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

export const CircularProgress = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid ${props => props.theme.colors.lighterGray};
  border-top: 4px solid ${props => props.theme.colors.black};
  border-radius: 50%;
  animation: ${rotate} 1s linear infinite;
`

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
`

export const MyDriveContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 18px;
	height: 100%;
`

export const MyDriveContent = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	gap: 16px;
	max-height: calc(100vh - 490px);
	overflow-y: auto;
	padding-right: 8px;

	& > div {
		flex: 0 0 calc(50% - 8px);
		margin: 0;
	}

	&::-webkit-scrollbar {
		width: 6px;
	}

	&::-webkit-scrollbar-track {
		background: ${props => props.theme.colors.highClearGray};
	}

	&::-webkit-scrollbar-thumb {
		background: ${props => props.theme.colors.lighterGray};
		border-radius: 3px;
	}
`

export const MyDriveDetailContent = styled.div`
	display: flex;
	flex-direction: column;
  gap: 16px;
  max-height: calc(100vh - 450px);
  overflow-y: auto;
  padding-right: 8px;
	
	& > div {
		width: 100%;
	}

  &::-webkit-scrollbar {
      width: 6px;
  }

  &::-webkit-scrollbar-track {
      background: ${props => props.theme.colors.highClearGray};
  }

  &::-webkit-scrollbar-thumb {
      background: ${props => props.theme.colors.lighterGray};
      border-radius: 3px;
  }
`
